import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import PersonCard from './PersonCard';
import { personCardStyles } from './styles';
import AddOrEditPeople from './AddOrEditPeople';

export default function PeopleList() {
  const [isLoading, setIsLoading] = useState(false);
  const [people, setPeople] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewPersonModalOpen, setAddNewPersonModalOpen] = useState(false);

  const getPeople = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/person/?search=${searchText}`)
      .then(res => {
        setPeople(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewPersonModalClose = () => {
    getPeople();
    setAddNewPersonModalOpen(false);
  };

  useEffect(() => {
    // Fetch people on mount
    getPeople();
  }, [getPeople]);

  return (
    <>
      <SearchBar label="Search a person..." setQuery={setSearchText} />
      <div style={personCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewPersonModalOpen(true)}>
          Person
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={people}
            emptyMessage="No people found."
            // @ts-ignore
            CardComponent={PersonCard}
            onPersonDelete={getPeople}
            onPersonUpdate={getPeople}
          />
          <AddOrEditPeople
            onSave={onNewPersonModalClose}
            modalTitle="Add new person"
            isModalOpen={addNewPersonModalOpen}
            setModalOpen={setAddNewPersonModalOpen}
          />
        </>
      )}
    </>
  );
}
